import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { Gender } from '@essent/common';
import type { RadioItem } from '@innogy/common-ui/forms';
import type { FormPersonalDetails } from '@legacy/common-ui-shared-interfaces';
import { TrackToolStep } from '@analytics/models';
import { getItemTextValue } from '@core/jss-utils';
import type { InitialsConverter } from '@innogy/utils-deprecated';
import {
  initialsConverter,
  AutocompleteDirective,
  IsInvalidPipe,
} from '@innogy/utils-deprecated';
import { FormGroupState } from 'ngrx-forms';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  ProgressiveFormStepWrapperComponent,
  ProgressiveFormBodyDirective,
  ProgressiveFormSummaryDirective,
} from '@innogy/shared/progressive-form';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';
import {
  RadioComponent,
  InputErrorComponent,
  TextComponent,
  PhoneComponent,
  DatepickerComponent,
  EmailComponent,
} from '@innogy/common-ui/forms';

import { ProgressivePersonalDetailsRendering } from './progressive-personal-details-form.rendering';

@Component({
  selector:
    'wl-progressive-personal-details-form[rendering][trackStep][formState][progressiveFormSelectorKey]',
  templateUrl: './progressive-personal-details-form.component.html',
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    JssModule,
    CSCaptureDirective,
    RadioComponent,
    InputErrorComponent,
    TextComponent,
    AutocompleteDirective,
    PhoneComponent,
    DatepickerComponent,
    EmailComponent,
    ProgressiveFormSummaryDirective,
    CSMaskDirective,
    IsInvalidPipe,
  ],
})
export class ProgressivePersonalDetailsFormComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ProgressivePersonalDetailsRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<FormPersonalDetails>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() maximumDateOfBirth?: Date;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() minimumDateOfBirth?: Date;

  salutationOptions: RadioItem[] = [];

  _initialsConverter?: InitialsConverter = initialsConverter();

  ngOnInit(): void {
    this.salutationOptions = [
      {
        label: getItemTextValue(this.rendering, 'salutationMaleOptionLabel'),
        value: `${Gender.MALE}`,
      },
      {
        label: getItemTextValue(this.rendering, 'salutationFemaleOptionLabel'),
        value: `${Gender.FEMALE}`,
      },
      {
        label: getItemTextValue(
          this.rendering,
          'salutationGenderNeutralOptionLabel'
        ),
        value: `${Gender.OTHER}`,
      },
    ];
  }

  selectedSalutationOption(
    salutationOptions: RadioItem[],
    selectedSalutation?: Gender
  ) {
    return salutationOptions
      .filter((option) => option.value !== Gender.OTHER)
      .find((option) => option.value === selectedSalutation)?.label;
  }
}
